import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { PortalCurrencyPipe } from '@app/pipes/portal-currency.pipe';

@Component({
  selector: 'cashback-badge',
  templateUrl: './cashback-badge.component.html',
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CashbackBadgeComponent {
  @Input() amount: number;

  portalCurrency = inject(PortalCurrencyPipe);

  get label() {
    return `You'll earn ${this.portalCurrency.transform(this.amount)} cashback`;
  }
}
